var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('Header'),_vm._v(" "),_c('el-container',{staticClass:"mainframe"},[_c('el-container',[_c('el-aside',[_c('SidebarNew')],1),_vm._v(" "),_c('el-container',[_c('el-main',[_c('router-view')],1),_vm._v(" "),_c('el-footer',[_c('Footer')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df6a5144","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Layout.vue
// module id = null
// module chunks = 